import styles from './index.module.css'

import * as React from 'react'

import { useTranslation } from '@disco/i18n/use-translation'

import ErrorIllustration from 'assets/icons/not-found.svg'

// `common` rather than a per-app namespace: this renders in the app (error
// boundary, signup) and in cl (_app), which load different namespace sets.
export default function ErrorPage({
  reloading,
}: {
  reloading?: boolean
}): React.ReactElement {
  const { t } = useTranslation('common', { useSuspense: false })

  const body = reloading
    ? t(
        'common:discoHasEncounteredAnInternalErrorAndWillReload',
        'DISCO has encountered an internal error and the team have been notified. This page will reload automatically.',
      )
    : t(
        'common:discoHasEncounteredAnInternalError',
        'DISCO has encountered an internal error and the team have been notified.',
      )

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <ErrorIllustration className={styles.illustration} />
        <div className={styles.textBlock}>
          <h1 className={styles.title}>
            {t('common:oopsSomethingWentWrong', 'Oops! Something went wrong')}
          </h1>
          <p className={styles.subtitle}>
            {t('common:internalError', 'Internal error')}
          </p>
          <p className={styles.body}>{body}</p>
        </div>
      </div>
    </div>
  )
}
